import React from "react";
import { Link } from "react-router-dom";
import { privatePartyPackages } from "../data/packages";
import { CARD_PAYMENT_POLICY } from "../data/bookingPolicies";
import PrivatePartyOffer from "./PrivatePartyOffer";
import PrivatePackageCard from "./PrivatePackageCard";

export default function PrivatePartyPackages({ context = "page", headingId }) {
  return (
    <>
      <PrivatePartyOffer headingId={headingId} />
      <div className="packages-grid">
        {privatePartyPackages.map((pkg) => (
          <PrivatePackageCard key={pkg.id} pkg={pkg} context={context} />
        ))}
      </div>
      <p className="private-party-payment-note">
        Optional add-ons are priced separately. {CARD_PAYMENT_POLICY}{" "}
        {context === "home" ? (
          <Link to="/packagesdetail#booking-policies">
            View all booking policies.
          </Link>
        ) : (
          <a href="#booking-policies">View all booking policies.</a>
        )}
      </p>
    </>
  );
}
